// Permission tree as returned by the API (permissions_check / permissions_role):
// parent = access to the module (e.g. PARCELS = parcels list), children =
// actions inside it. The backend saves the parent from `group.check` and each
// child from `perm.check` (see UserController::applyPermsTree).

export function syncEnabled(group: any) {
  group.enabled = (group.permissions || []).filter((p: any) => p.check).map((p: any) => p.key);
}

export function prepareTree(groups: any[]) {
  groups.forEach((group) => syncEnabled(group));
  return groups;
}

// key → check map of the saved state, used to count / highlight unsaved changes
export function snapshotTree(groups: any[]) {
  const map: Record<string, boolean> = {};
  groups.forEach((group: any) => {
    map[group.key] = !!group.check;
    (group.permissions || []).forEach((p: any) => (map[p.key] = !!p.check));
  });
  return map;
}

export function isChanged(saved: Record<string, boolean>, key: string, check: boolean) {
  return key in saved && saved[key] !== !!check;
}

export function countChanges(groups: any[], saved: Record<string, boolean>) {
  let n = 0;
  groups.forEach((group: any) => {
    if (isChanged(saved, group.key, group.check)) n++;
    (group.permissions || []).forEach((p: any) => {
      if (isChanged(saved, p.key, p.check)) n++;
    });
  });
  return n;
}
